/**
 * La eliminación de cuenta pendiente, para las pantallas de acceso.
 *
 * Dos fuentes, cada una para su momento:
 * - Al pedirla, la sesión se cierra en el acto. Lo que se acaba de programar se
 *   deja en `sessionStorage` para que la pantalla de acceso diga hasta cuándo se
 *   puede volver. Sólo en esta pestaña: no es algo que deba quedar a la vista
 *   en otro navegador.
 * - Al volver a entrar, la marca viaja en la sesión (`user_metadata`, la pone el
 *   worker): el panel sabe sin preguntar que tiene que enseñar «restaurar».
 */
import type { Session } from '@supabase/supabase-js'

const KEY = 'veltica:account-deletion'

export function rememberScheduledDeletion(purgeAt: string): void {
  try { sessionStorage.setItem(KEY, purgeAt) } catch { /* sin almacenamiento, sin aviso: no es crítico */ }
}

export function readScheduledDeletion(): string | null {
  try { return sessionStorage.getItem(KEY) } catch { return null }
}

export function clearScheduledDeletion(): void {
  try { sessionStorage.removeItem(KEY) } catch { /* nada que limpiar */ }
}

/** La fecha del borrado definitivo, si la cuenta de esta sesión está en camino de borrarse. */
export function deletionPurgeAt(session: Session | null): string | null {
  const value = (session?.user.user_metadata as { deletion_purge_at?: unknown } | undefined)?.deletion_purge_at
  return typeof value === 'string' && value ? value : null
}
